import { render, staticRenderFns } from "./bookinglist.vue?vue&type=template&id=2c8996cf&scoped=true"
import script from "./bookinglist.vue?vue&type=script&lang=js"
export * from "./bookinglist.vue?vue&type=script&lang=js"
import style0 from "./bookinglist.vue?vue&type=style&index=0&id=2c8996cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8996cf",
  null
  
)

export default component.exports